"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsAborted = exports.getError = exports.getIsFetching = void 0;

var getIsFetching = function getIsFetching(state) {
  return Boolean(state.apiFlow.asyncDownload.isFetching);
};

exports.getIsFetching = getIsFetching;

var getError = function getError(state) {
  return state.apiFlow.asyncDownload.error;
};

exports.getError = getError;

var getIsAborted = function getIsAborted(state) {
  return state.apiFlow.asyncDownload.isAborted;
};

exports.getIsAborted = getIsAborted;